<div class="row align-items-center justify-content-center h-100">
    <div class="col-md-6">
        <div class="text-center">
            <h1 [innerText]="'GENERAL.ACCESS_NOT_AUTHORISED' | translate"></h1>
            <button type="button" class="btn btn-primary" routerLink="/admin" [innerText]="'GENERAL.HOME' | translate"></button>
        </div>
    </div>
</div>
